// extracted by mini-css-extract-plugin
module.exports = {"extraWalletLabel":"_4176930","promotionCheckbox":"_70e98d6","freeBetIcon":"_2846c88","srOnly":"_c24c5aa"};